<template>
  <div>
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center">
        <vx-card class="w-auto mr-4 cursor-pointer" @click="updateTab(0)"
                 :style="`background: ${tab === 0 ? '#' + color : ''}`">
          <div class="flex items-center">
            <feather-icon icon="PaperclipIcon" svgClasses="h-8 w-8 mr-4"/>
            <h3 class="">Stream</h3>
          </div>
        </vx-card>
        <vx-card class="w-auto mr-4 cursor-pointer" @click="updateTab(1)"
                 :style="`background: ${tab === 1 ? '#' + color : ''}`">
          <div class="flex items-center">
            <feather-icon icon="BookIcon" svgClasses="h-8 w-8 mr-4"/>
            <h3 class="">Assignments</h3>
          </div>
        </vx-card>
        <!---
        <vx-card class="w-auto mr-4 cursor-pointer" @click="updateTab(2)"
                 :style="`background: ${tab === 2 ? '#' + color : ''}`">
          <div class="flex items-center">
            <feather-icon icon="InboxIcon" svgClasses="h-8 w-8 mr-4"/>
            <h3 class="">Material</h3>
          </div>
        </vx-card>
        --->
        <vx-card class="w-auto mr-4 cursor-pointer" @click="updateTab(3)"
                 :style="`background: ${tab === 3 ? '#' + color : ''}`">
          <div class="flex items-center">
            <feather-icon icon="VideoIcon" svgClasses="h-8 w-8 mr-4"/>
            <h3 class="">Meetings</h3>
          </div>
        </vx-card>
        <vx-card class="w-auto mr-4 cursor-pointer" @click="updateTab(4)"
                 :style="`background: ${tab === 4 ? '#' + color : ''}`">
          <div class="flex items-center">
            <feather-icon icon="UsersIcon" svgClasses="h-8 w-8 mr-4"/>
            <h3 class="">People</h3>
          </div>
        </vx-card>
      </div>
      <feather-icon class="cursor-pointer" icon="EditIcon" @click="editClassroom" svgClasses="h-8 w-8"/>
    </div>
    <vs-popup :active.sync="editClassroomPopup"  title="Edit Classroom">
      <div class="popup-input" v-if="classroom">
        <p class="mb-1 font-semibold">Name</p>
        <vs-input v-model="classroom.name" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Description</p>
        <vs-input v-model="classroom.description" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Thumbnail</p>
        <vs-input v-model="classroom.thumbnail" class="mb-3 w-full"/>

        <p class="mb-1 font-semibold">Color</p>
        <div class="flex items-center mb-3">
          <vs-radio v-model="classroom.color" vs-value="1863CA" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #1863CA">Blue</vs-radio>
          <vs-radio v-model="classroom.color" vs-value="32AC71" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #32AC71">Green</vs-radio>
          <vs-radio v-model="classroom.color" vs-value="DC248C" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #DC248C">Pink</vs-radio>
          <vs-radio v-model="classroom.color" vs-value="DF6D0A" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #DF6D0A">Orange</vs-radio>
          <vs-radio v-model="classroom.color" vs-value="8D32DD" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #8D32DD">Purple</vs-radio>
          <vs-radio v-model="classroom.color" vs-value="5B5F64" vs-name="defaultClassroomColor" class="mr-3 p-2 font-bold rounded-lg" style="background: #5B5F64">Grey</vs-radio>
        </div>
        <vs-input v-model="classroom.color" class="mb-3 w-full"/>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'ClassroomTopBar',
  data () {
    return {
      editClassroomPopup: false,
      classroom: null
    }
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    tab: {
      type: Number,
      required: true
    },
    color: {
      type: String
    }
  },
  methods: {
    updateTab (id) {
      this.$emit('updateTab', id)
    },
    editClassroom () {
      this.$http.get(`classrooms/properties/${this.classroomId}`)
        .then(response => {
          if (response.status === 200) {
            this.classroom = response.data.data
            this.editClassroomPopup = true
          }
        })
    },
    updateClassroom () {
      this.$http.post(`classrooms/properties/${this.classroomId}`, this.classroom)
        .then(response => {
          if (response.status === 200) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Classroom Updated Successfully',
              text: `${this.classroom.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch(exception => {
          this.$emit('refresh')
          let error = 'An unknown error occurred while updating this classroom'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Update Meeting',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    }
  },
  watch: {
    editClassroomPopup (val) {
      if (!val) this.updateClassroom()
    }
  }
}
</script>

<style scoped>

</style>
